import { useState } from 'react'
import { Plus, Pencil, Mic, Camera } from 'lucide-react'
import useTaskStore from '../store/taskStore'
import { useT } from '../i18n/useT'

export default function FAB() {
  const t = useT()
  const [open, setOpen] = useState(false)
  const { openQuickAdd } = useTaskStore()

  const OPTIONS = [
    { mode: 'image',  icon: Camera, labelKey: 'fab_image',  delay: '0s'    },
    { mode: 'voice',  icon: Mic,    labelKey: 'fab_voice',  delay: '0.05s' },
    { mode: 'manual', icon: Pencil, labelKey: 'fab_manual', delay: '0.1s'  },
  ]

  const handleOption = (mode) => { setOpen(false); openQuickAdd(mode) }

  // Close ONLY on click, never on pointerdown — closing on pointerdown
  // unmounts the backdrop before the synthesized click can land on it,
  // letting the tap fall through to whatever element sits underneath
  // (e.g. a task card), opening its edit modal.
  return (
    <>
      {open && (
        <div
          className="fab-backdrop"
          onPointerDown={e => { e.stopPropagation() }}
          onClick={e => { e.stopPropagation(); setOpen(false) }}
          aria-hidden="true"
        />
      )}
      <div className="fab-container" id="tour-fab">
        {open && OPTIONS.map(({ mode, icon: Icon, labelKey, delay }) => (
          <div key={mode} className="fab-option" style={{ animationDelay: delay }}>
            <span className="fab-option-label">{t(labelKey)}</span>
            <button className={`fab-option-btn fab-option-btn--${mode}`} onClick={() => handleOption(mode)}>
              <Icon size={20} />
            </button>
          </div>
        ))}

        <button
          className={`fab-main${open ? ' open' : ''}`}
          onClick={() => setOpen(o => !o)}
          aria-label={t('sb_add')}
        >
          <Plus size={26} strokeWidth={2.5} />
        </button>
      </div>
    </>
  )
}
